import React, { useState, useEffect } from "react";
import Button from "../../components/Button";
import ImageDropdown from "../../components/ImageDropdown";

const PATH_TO_BACKEND = process.env.REACT_APP_ROOF_PATH_TO_BACKEND;

function AddressAndCoordinates({
  addressAndCoordinates,
  setAddressAndCoordinates,
  setSelfPickUp,
  dealId,
  setDistanceFromFactory,
  region
}) {
  const [selectedOption, setSelectedOption] = useState(
    dealId && !isNaN(Number(dealId)) ? "fromDeal" : "manual"
  );
  const [inputValue, setInputValue] = useState(""); // Универсальный ввод (может быть адресом или координатами)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    setInputValue("")
  }, [region])

  useEffect(() => {
    if (dealId && !isNaN(Number(dealId))) {
      // Вызываем handleOptionChange с правильным значением
      handleOptionChange("fromDeal");
    }
  }, [dealId]);

  const handleOptionChange = (value) => {
    setSelectedOption(value);
  
    if (value === "fromDeal") {
      setLoading(true);
      setError(null);
  
      // Шаг 1: Запрос адреса и координат из сделки
      fetch(`${PATH_TO_BACKEND}/api/address`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ dealId }),
      })
        .then((response) => response.json())
        .then((addressData) => {
          // Выводим данные из первого запроса
          console.log("Данные из /api/address:", addressData);
  
          if (addressData.address && addressData.coordinates) {
            // Устанавливаем адрес и координаты
            setAddressAndCoordinates({
              address: addressData.address,
              coordinates: {
                latitude: parseFloat(addressData.coordinates.latitude),
                longitude: parseFloat(addressData.coordinates.longitude),
              },
            });
            setSelfPickUp(addressData.selfPickUp === true || addressData.selfPickUp === "true");
  
            // Шаг 2: Запрос расстояния от завода (после успешного завершения первого запроса)
            return fetch(`${PATH_TO_BACKEND}/api/getLocation`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                query: `${addressData.coordinates.latitude},${addressData.coordinates.longitude}`,
              }),
            });
          } else {
            throw new Error("Некорректные данные от /api/address");
          }
        })
        .then((response) => response.json())
        .then((locationData) => {
          // Выводим данные из второго запроса
          console.log("Данные из /api/getLocation:", locationData);
  
          if (locationData.distance_from_factory !== undefined) {
            // Устанавливаем расстояние от завода
            setDistanceFromFactory(locationData.distance_from_factory);
            console.log("Расстояние от завода:", locationData.distance_from_factory);
          } else {
            console.error("Ошибка: расстояние от завода не найдено");
          }
        })
        .catch((error) => {
          console.error("Ошибка при запросе к API:", error);
          setError("Ошибка получения данных");
        })
        .finally(() => setLoading(false));
    }
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const convertData = () => {
    if (inputValue.length < 4) {
      setError("Введите корректные данные");
      setSuccess(false);
      return;
    }

    setLoading(true);
    setError(null);

    fetch(`${PATH_TO_BACKEND}/api/getLocation`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: inputValue }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.address && data.coordinates) {
          setAddressAndCoordinates({
            address: data.address,
            coordinates: {
              latitude: parseFloat(data.coordinates.latitude),
              longitude: parseFloat(data.coordinates.longitude),
            },
          });
          setSuccess(true); // Успешное преобразование
          setError(null); // Сбрасываем ошибку

          // Устанавливаем расстояние до завода
          if (data.distance_from_factory !== undefined) {
            setDistanceFromFactory(data.distance_from_factory);
          }
        } else {
          setError("Не удалось преобразовать данные");
          setSuccess(false);
        }
      })
      .catch((error) => {
        console.error("Ошибка запроса:", error);
        setError("Ошибка получения данных");
        setSuccess(false);
      })
      .finally(() => setLoading(false));
  };

  const addressOptions = [
    ...(dealId && !isNaN(Number(dealId))
      ? [{ value: "fromDeal", label: "Подтягивать из сделки" }]
      : []),
    { value: "manual", label: "Ввести адрес или координаты" },
  ];

  return (
    <div className="p-3">
      <label
        className="form-check-label fs-4 transition duration-300 transform hover:scale-110 focus:ring-2 focus:ring-primary focus:outline-none"
        title={addressAndCoordinates.address || "Адрес не указан"}
      >
        Адрес клиента
      </label>

      <ImageDropdown
        options={addressOptions}
        selectedOption={selectedOption}
        onSelect={(value) => handleOptionChange(value)} // Передаем значение напрямую
      />

      {selectedOption === "manual" && (
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            value={inputValue}
            onChange={handleInputChange}
            placeholder="(например: 55.7558, 37.6173)"
          />
        </div>
      )}

      {/* Кнопка "Преобразовать" показывается ТОЛЬКО если выбран "Ввести адрес или координаты" */}
      {selectedOption === "manual" && (
        <>
          <Button onClick={convertData} loading={loading} label="Преобразовать" />

          {/* Ошибка (красный текст) только если manual */}
          {error && <p style={{ color: "red" }}>{error}</p>}

          {/* Успех (зеленый текст) только если manual */}
          {!error && success && (
            <p style={{ color: "green" }}>✅ Успешно преобразовано</p>
          )}
        </>
      )}
    </div>
  );
}

export default AddressAndCoordinates;
